module.exports = __webpack_public_path__ + "img/0S6A9549.31291277.jpg";